<template>
    <div>
        <div class="gradient text-white pa-2">
            <h3>{{ runner.equipe_name }} - {{ runner.runner_names }} #{{ runner.dossard }}</h3>
            <h5>{{ runner.course }}</h5>
        </div>

        <div class="d-flex justify-space-between align-center my-2 px-2">
            <div>
                Temps cumulé: <b>{{ runner.total.temps }}</b>
            </div>
        </div>
        <v-divider class="my-2"></v-divider>


        <div class="d-flex  align-center ga-2">
            <v-chip label class="gradient text-white">Kayak</v-chip>
            <div>
                <strong>{{ runner.kayak?.temps ?? '—' }}</strong>
                <div class="text">Clt {{ runner.kayak?.clt_sexe ?? '—' }}
                </div>
            </div>
        </div>
        <v-divider class="my-2"></v-divider>




        <div class="d-flex align-center ga-2">
            <v-chip label class="gradient text-white">Trail</v-chip>
            <div>
                <strong>{{ runner.trail?.temps ?? '—' }}</strong>
                <div class="text">Clt {{ runner.trail?.clt_sexe ?? '—' }} </div>
            </div>
        </div>
        <v-divider class="my-2"></v-divider>
        <div class="d-flex  align-center ga-2">
            <v-chip label class="gradient text-white">Tir à l'arc</v-chip>
            <div>
                <strong>{{ runner.penalite.temps }}</strong>
            </div>
        </div>




    </div>
</template>

<script>

export default {
    props: ["runner"],
    methods: {

    },
};
</script>

<style lang="scss" scoped></style>